// extracted by mini-css-extract-plugin
export var container = "_mx-0";